import { FILTER_PROMPTS } from './types';

export const filterPrompts = filter => async dispatch => {
  dispatch({ type: FILTER_PROMPTS, payload: { filter } });
};
